import { Dictionary } from 'src/app/core/model/dictionary';
import { WaitTime, Website } from 'src/app/referral/model/community-provider-search-result';
import { Organization } from 'src/app/core/model/organization';
import { Address } from 'src/app/member/model/member';
import { CommunityProviderProgramIdentifier } from '../model/community_provider_program_identifier';

export interface OpenTime
{
    id: number;
    version: number;
    day: string;
    from: Date;
    to: Date;
}
export class CommunityProviderProgramEdit
{
    public id = null;
    public name = '';
    public description = '';
    public cost = '';
    public eligibility = '';
    public languages: Dictionary[] = [];
    public enhancedServices: Dictionary[] = [];
    public organization: Organization;
    public channel: any;
    public serviceCategory: any;
    public address: Address;
    public openingTimes: OpenTime[] = [];
    public phoneNumber = '';
    public faxNumber = '';
    public url = '';
    public email = '';
    public streetLine: string;
    public streetLineAdditional: string;
    public postalCode: string;
    public city: string;
    public state: Dictionary;
    public country: Dictionary;
    public programContactName = '';
    public referralContactName = '';
    public referralPhoneNumber = '';
    public referralFaxNumber = '';
    public referralUrl = '';
    public referralEmail = '';
    public acceptingDisabledPatients: any;
    public acceptingElectronicReferrals: any;
    public acceptingNewPatients: any;
    public acceptingSelfReferrals: any;
    public alias: string;
    public alertDescription: string;
    public applicationProcess: string;
    public areaServedCities: Dictionary[] = [];
    public areaServedCounties: Dictionary[] = [];
    public areaServedZipCodes: Dictionary[] = [];
    public capacity: string;
    public documentationRequired: string;
    public incomeRequirements: Dictionary[] = [];
    public lgbtq: any;
    public licenses: Dictionary[] = [];
    public otherIdentifiers: CommunityProviderProgramIdentifier[] = [];
    public paymentMethods: Dictionary[] = [];
    public resourceStatus: Dictionary;
    public submittingOrganization: Organization;
    public targetedDemographics: Dictionary[] = [];
    public targetedPopulations: Dictionary[] = [];
    public providerTaxonomies: Dictionary[] = [];
    public waitTimes: WaitTime[] = [];
    public websites: Website[] = [];
    public directoryManagerName: string;
    public directoryManagerEmail: string;
    public directoryManagerNotificationPreference: string;
    public ableToConductScreenings: any;
    public informationalOnly: any;
    public referralEmergencyNumber: string;
    public referralExtension: string;
    public allowDuplicateReferrals = false;
}
